// src/components/CookieConsent.jsx
import React, { useState, useEffect } from 'react';
import './CookieConsent.scss';

const CookieConsent = ({ setShowCookieBanner }) => {
    const [skipping, setContent] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);
    const [cookiePreferences, setCookiePreferences] = useState({
        strictlyNecessary: true,
        performance: true,
        functional: true,
        targeting: true
    });

    // debugger;


    // Initialize preferences from localStorage if they exist
    useEffect(() => {
        //const skipping = true;

        //skip privacy policy page
        const url = new URL(window.location.href);
        const path = url.pathname;

        let skipContent;
        // debugger;
        if (path.includes('/privacy-policy')) {
            //    skipping = true;
            skipContent = true;
        } else {
            skipContent = false

        }

        setContent(skipContent);

        const savedPreferences = localStorage.getItem('cookiePreferences');
        if (savedPreferences) {
            setCookiePreferences(JSON.parse(savedPreferences));
        }
    }, []);

    const handleToggle = (category) => {
        if (category === 'strictlyNecessary') return; // Can't disable necessary cookies
        setCookiePreferences(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    const handleAcceptAll = () => {
        const allAccepted = {
            strictlyNecessary: true,
            performance: true,
            functional: true,
            targeting: true
        };
        setCookiePreferences(allAccepted);
        savePreferences(allAccepted);
        setShowCookieBanner(false);
    };

    const handleRefuseAll = () => {
        window.confirm("To use the website, you must accept all cookies");
    }

    const handleSavePreferences = () => {
        savePreferences(cookiePreferences);
        setShowCookieBanner(false);
    };

    const savePreferences = (preferences) => {
        localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
        localStorage.setItem('cookieConsent', 'given');

        // Apply cookie settings in your app
        // console.log('Cookie preferences saved:', preferences);
        // Here you would initialize cookies based on preferences
    };

    // debugger;
    if (skipping) {
        return <div></div>;
    }

    return (
        <div className={`cookie-consent ${showPreferences ? 'expanded' : ''}`}>
            <div className="cookie-content">
                <div className="cookie-header">
                    <h3>Your Privacy Matters</h3>
                    <button className="close-btn" onClick={() => setShowCookieBanner(false)}>X
                    </button>
                </div>

                <div className="cookie-body">
                    <p>We, Sonova New Zealand Wholesale Ltd, use cookies and other tracking tools for technical purposes and, with your consent, for other purposes, such as to measure and improve the performance of the website (performance and analytical cookies); to provide enhanced functionalities and personalization (functional cookies), to assist you in our marketing efforts (targeting or advertising cookies).
                    </p>
                    <p>You can manage your choice by clicking on the "Cookie Preferences" link, or accept all cookies by clicking on "Accept All" button, or refuse all cookies by clicking on "Refuse All". Please know that refusing cookies may lead to the absence of certain functionalities. You have the possibility to withdraw your consent to cookies at any time during your visit. For more information consult our <a href="/privacy-policy">cookie privacy notice</a>.</p>

                    {showPreferences ? (
                        <div className="preferences-panel">
                            <div className="preference-item disabled">
                                <div>
                                    <h4>Strictly Necessary Cookies</h4>
                                    <p>Strictly necessary cookies are always active because they contribute to the proper functioning of the website and make it usable by allowing basic functions such as page navigation and access to secure areas of the website.</p>
                                </div>
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={true}
                                        disabled
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>

                            <div className="preference-item">
                                <div>
                                    <h4>Performance & Analytics</h4>
                                    <p>Performance and analytical cookies allow us to understand how you interact with the website so that we can measure and improve its performance. These cookies help us to know which pages are most and least popular and to see how you move through the website. If you do not allow these cookies, we will not know when you have visited our website.</p>
                                </div>
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={cookiePreferences.performance}
                                        onChange={() => handleToggle('performance')}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>

                            <div className="preference-item">
                                <div>
                                    <h4>Functional Cookies</h4>
                                    <p>Functional cookies allow the website to provide enhanced functionality and personalization. For example, they can store information that changes the way the website behaves or looks, such as your preferred language or region you are in. If you do not allow these cookies, some or all of these services may not function properly.
                                    </p>
                                </div>
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={cookiePreferences.functional}
                                        onChange={() => handleToggle('functional')}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>

                            <div className="preference-item">
                                <div>
                                    <h4>Targeting & Advertising</h4>
                                    <p>Targeting or advertising cookies are used to track you when you visit our website. They may be set by advertising partners to profile your interests based on your browsing. If you do not allow these cookies, you will continue to see basic ads on your browser that are generic and not based on your interests.</p>
                                </div>
                                <label className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={cookiePreferences.targeting}
                                        onChange={() => handleToggle('targeting')}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className="cookie-footer">
                    <div className="links py-3">
                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
                        <a href="#" onClick={(ev) => { ev.preventDefault(); setShowPreferences(!showPreferences); }}>
                            {showPreferences ? 'Hide Preferences' : 'Customize Preferences'}
                        </a>
                    </div>

                    <div className="buttons">
                        <button className="btn reject" onClick={handleRefuseAll}>
                            Refuse All
                        </button>
                        {showPreferences ? (
                            <button className="btn save" onClick={handleSavePreferences}>
                                Save Preferences
                            </button>
                        ) : null}
                        <button className="btn accept" onClick={handleAcceptAll}>
                            Accept All
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};




export default CookieConsent;